export const RATE_UPDATE = '@rate/update';
export const RATE_REMOVE = '@rate/remove';
export const LAST_WEEK_RATES_UPDATE = '@rate/last-week-rate-update';
export const TX_FIAT_RATE_UPDATE = '@rate/tx-fiat-rate-update';
